<template>
  <v-container v-if="renderComponent">
    <v-tabs centered>
      <v-tab>For Tenants</v-tab>
      <v-tab>For Landlords</v-tab>
      <v-tab-item>
        <v-row no-gutters>
          <v-col
            cols="12"
            md="4"
            class="px-12"
            style="position: relative;"
            :key="index"
            v-for="(block, index) in tenants"
          >
            <div class="py-5">
              <div class="icon-circle mb-5">
                <v-img contain :src="block.img"></v-img>
              </div>
              <p class="primary--text headline feature-count py-1">{{index + 1}}.</p>
              <h3 class="title px-2 py-1">{{block.title}}</h3>
              <p class="px-2">{{block.body}}</p>
            </div>
          </v-col>
        </v-row>
        <div class="py-5 d-flex column justify-center">
          <v-btn rounded color="primary" :to="{name: 'renting'}">Show More</v-btn>
        </div>
      </v-tab-item>
      <v-tab-item>
        <v-row>
          <v-col
            cols="12"
            md="4"
            class="px-12"
            style="position: relative;"
            :key="index"
            v-for="(block, index) in landlords"
          >
            <div class="icon-circle">
              <v-img contain :src="block.img"></v-img>
            </div>
            <p class="primary--text headline feature-count py-1">{{index + 1}}.</p>
            <h3 class="title px-2 py-1">{{block.title}}</h3>
            <p class="px-2">{{block.body}}</p>
          </v-col>

          <v-btn rounded color="primary" class="mx-auto" :to="{name: 'renting-out'}">Show More</v-btn>
        </v-row>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      renderComponent: false,
      tenants: [
        {
          img: require("@/assets/home/pics_active-local-listing.svg"),
          title: "Active Local Listings",
          body:
            "Only Most Recent and active listings that are available for rent in the area",
        },
        {
          img: require("@/assets/home/pics_quick-easy-nav.svg"),
          title: "Quick and Easy Navigation",
          body:
            "You can easily filter the area or the search criteria to find the most suitable house or apartment to rent for you",
        },
        {
          img: require("@/assets/home/pics_safe-reliable.svg"),
          title: "Safe and Reliable",
          body:
            "Dealing with Local Rent Online you can be sure that you and your information is safe and will not be passed on to third parties under any circumstances",
        },
      ],
      landlords: [
        {
          img: require("@/assets/home/pics_fast-easy-listing.svg"),
          title: "Fast and Easy Listing",
          body:
            "It takes just a few moments to make your new listing visible nationwide.",
        },
        {
          img: require("@/assets/home/pics_almost-free.svg"),
          title: "Almost Free",
          body:
            "You do not have to spend $$$ to find a good renter. Most of them are just within your reach",
        },
        {
          img: require("@/assets/home/pics_long-term-relationship.svg"),
          title: "Long Term Relationships",
          body:
            "Our job at LocalRent.Online is to make your life easier to focus on the things that are important to you by taking away part of your hassle of finding a good tenant.",
        },
      ],
    };
  },
  methods: {
    forceRerender() {
      this.renderComponent = false;

      setTimeout(() => {
        this.renderComponent = true;
      }, 280);
    },
  },
  created() {
    // fix not centered slider
    this.forceRerender();
  },
};
</script>

<style lang="scss" scoped>
.feature-count {
  left: 15px;
  position: absolute;
  font-size: 2.375rem;
  line-height: 1;
  margin-right: 0;
}
</style>